import React from "react";

function Header() {
  return (
    <div className="flex flex-col md:flex-row p-10 text-center sm:text-center md:text-left">
      <section className="lg:w-3/5 lg:flex lg:flex-col lg:justify-center">
        <h1 className="text-4xl sm:text-5xl font-extrabold -mt-9 text-green-500 lg:text-6xl ">
          TRAVEL THE WORLD!
        </h1>
        <h1 className="text-slate-500 text-1xl mb-3">Let the Moments Count</h1>
        <hr />
        <p className="hidden sm:block mb-5">
          Each part of the world we're lucky to see, is nature showing us the
          beauty that lies within us. For only beauty can behold beauty.
        </p>
        <button className="p-2 text-white text-center hover:bg-green-600 hover:scale-105 transition duration-700 rounded-md bg-orange-600">
          Book an Experience with us!
        </button>
      </section>
      <section className="lg:w-150 lg:flex-grow-2 mt-2">
        <img
          className="w-full max-w-xl -mb-10 flex-grow"
          src="/images/hero-img.png"
          alt="3d Illustration of a model"
        />
      </section>
    </div>
  );
}

export default Header;
